import React from 'react';
import ChatScreen from './page/ChatScreen';
import "../node_modules/bootstrap/dist/css/bootstrap.min.css"
import "./styles/common.css"

const App = () => {
  return (
    <>
      <ChatScreen />
    </>
  );
};

export default App;